export default function getExtensionFromFileName(fileName) {
    if (!fileName) {
        return null;
    }
    var start = fileName.lastIndexOf('.');
    if (start > 0) {
        return fileName.substr(start).toLowerCase();
    }
    return null;
}
export function getExtensionWithoutDotFromFileName(fileName) {
    var extension = getExtensionFromFileName(fileName);
    return extension ? extension.replace('.', '') : null;
}
//# sourceMappingURL=getExtensionFromFileName.js.map